/**
 * Google Maps API Service
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";

const MODULE_NAME = 'app.core/services/google-maps-api';
const log = debug(MODULE_NAME);


//
// Dependencies
import GoogleMapsApiLoader from '@vendor/google-maps-api-loader';
import { GOOGLE_API_KEY } from './config';


//
// Config
const GOOGLE_API_OPTIONS = {
	libraries: ['places'],
	apiKey: GOOGLE_API_KEY,
};


//
// Exports
/**
 * @type {Promise.<google>}
 */
export default GoogleMapsApiLoader(GOOGLE_API_OPTIONS);





// WEBPACK FOOTER //
// ./client/src/core/services/google-maps-api/index.js